module.exports = __webpack_public_path__ + "img/nav.89af62f2.png";